import { actionCopyDe } from "./actionCopy";

export const authCopyDe = {
    backToWebsite: "Zurück zur Website",
    languageLabel: "Language / Sprache / Sprog / Langue",
    languageDescription:
        "Change the app language. Sprache der App ändern. Skift appsprog. Changer la langue de l'application.",
    chooseLanguage: "Sprache wählen",
    or: "ODER",
    next: actionCopyDe.next,
    submit: actionCopyDe.submit,
    continue: actionCopyDe.continue,
    logout: "Abmelden",
    verifyingAuthentication: "Authentifizierung wird überprüft...",
    signUpSignIn: "Registrieren / Anmelden",
    signIn: "Anmelden",
    signUp: "Registrieren",
    signUpWith: (name) => `Registrieren mit ${name}`,
    joinStudy: (studyName) => `${studyName} beitreten`,
    alreadyHaveAccount: "Sie haben bereits ein Konto?",
    dontHaveAccount: "Noch kein Konto?",
    signInWithPasswordInstead: "Stattdessen mit Passwort anmelden",
    contactMethodLabel: "Kontaktmethode",
    patientRole: "Patient",
    forgotPassword: "Passwort vergessen",
    confirmYourAccount: "Konto bestätigen",
    choosePassword: "Passwort wählen",
    confirmPassword: "Passwort bestätigen",
    showPassword: "Passwort anzeigen",
    passwordsDontMatch: "Passwörter stimmen nicht überein",
    passwordsMatch: "Passwörter stimmen überein",
    passwordAllGood: "Alles bestens!",
    passwordRequirementMinLength: "Muss mindestens 8 Zeichen lang sein",
    passwordRequirementLowercase: "Muss einen Kleinbuchstaben enthalten",
    passwordRequirementUppercase: "Muss einen Großbuchstaben enthalten",
    passwordRequirementNumber: "Muss eine Zahl enthalten",
    passwordRequirementSpecial: "Muss ein Sonderzeichen enthalten",
    setYourPassword: "Passwort festlegen",
    setPasswordDescription: "Erstellen Sie ein sicheres Passwort für Ihr Konto",
    settingPassword: "Passwort wird festgelegt...",
    smartAuthHint:
        "Geben Sie die E-Mail-Adresse oder Telefonnummer ein, an die Ihre Patient-Watch-Einladung gesendet wurde.",
    usePhoneInstead: "Telefonnummer verwenden",
    useEmailInstead: "E-Mail verwenden",
    phoneVerificationHint: "Wir senden Ihnen einen Bestätigungscode an Ihr Telefon.",
    phoneSignupHint:
        "Wir senden Ihnen einen Bestätigungscode an Ihr Telefon. Es können Standard-SMS-Gebühren anfallen.",
    loggingIn: "Anmeldung läuft...",
    sendingCode: "Code wird gesendet...",
    logIn: "Anmelden",
    sendCode: "Code senden",
    sendVerificationCode: "Bestätigungscode senden",
    sendingCodeEllipsis: "Code wird gesendet…",
    codeSent: "Code gesendet",
    codeSentToPhone: "Code an Ihr Telefon gesendet",
    verificationCodeSent: "Bestätigungscode gesendet",
    emailFallbackCodeSent: "Wir konnten keine SMS senden und haben Ihnen stattdessen einen Code per E-Mail geschickt.",
    checkFormAndTryAgain: "Bitte überprüfen Sie das Formular und versuchen Sie es erneut.",
    somethingWentWrong: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    newUser: "Neuer Benutzer",
    invitationFound: "Einladung gefunden",
    accountFound: "Konto gefunden",
    accountFoundUseEmailSmsNotReady:
        "Konto gefunden. Melden Sie sich mit Ihrer E-Mail an. SMS-Anmeldung ist für diese Nummer auf Ihrem Konto noch nicht eingerichtet.",
    smsLoginContactCareTeam:
        "SMS-Anmeldung ist für diese Nummer nicht verfügbar. Bitte wenden Sie sich an das Team, das Sie eingeladen hat.",
    authMethodError: "Authentifizierungsfehler",
    smsLoginUnavailable:
        "SMS-Anmeldung ist für diese Nummer noch nicht verfügbar. Melden Sie sich stattdessen mit der E-Mail Ihres Kontos an.",
    email: "E-Mail",
    emailTab: "E-Mail",
    phoneTab: "Telefon",
    emailPlaceholder: "z. B. name@firma.de",
    password: "Passwort",
    phone: "Telefonnummer",
    enterEmailAddress: "Geben Sie Ihre E-Mail-Adresse ein",
    enterPhoneNumber: "Geben Sie Ihre Telefonnummer ein",
    enterPhoneWithCountryCode: "Geben Sie eine Telefonnummer mit Ländervorwahl ein.",
    forgotPasswordEmailHint:
        "Geben Sie die E-Mail Ihres Kontos ein. Wir senden Ihnen einen Bestätigungscode zum Zurücksetzen Ihres Passworts.",
    forgotPasswordPhoneHint:
        "Geben Sie die Telefonnummer Ihres Kontos ein. Wir senden Ihnen einen Bestätigungscode per SMS.",
    sending: "Wird gesendet...",
    backToSignIn: "Zurück zur Anmeldung",
    backToForgotPassword: "Zurück zu Passwort vergessen",
    backToConfirmAccount: "Zurück zur Kontobestätigung",
    backToSignup: "Zurück zur Registrierung",
    verifyYourAccount: "Konto verifizieren",
    verifyEmailCodeHint: "Geben Sie den Bestätigungscode ein, der an Ihre E-Mail-Adresse gesendet wurde.",
    verifySmsCodeHint: "Geben Sie den Code ein, der an Ihre Telefonnummer gesendet wurde.",
    verifying: "Wird überprüft…",
    resendCode: "Code erneut senden",
    didNotReceiveCode: "Keinen Code erhalten?",
    resendConfirmationCode: "Bestätigungscode erneut senden",
    needHelpContact: "Brauchen Sie Hilfe? Kontaktieren Sie",
    consentTermsPrefix: "Ich akzeptiere die",
    termsOfUse: "Nutzungsbedingungen",
    consentAnd: "und die",
    privacyPolicy: "Datenschutzrichtlinie",
    selectHospitalLabel: "In welchem Krankenhaus werden Sie für diese Behandlung betreut?",
    selectHospitalPlaceholder: "Krankenhaus auswählen",
    selectHospitalToContinue: "Bitte wählen Sie Ihr Krankenhaus, um fortzufahren.",
    ownOrganisationNameLabel: "Organisationsname",
    ownOrganisationNamePlaceholder: "z. B. Orthopädische Praxis Stadtmitte",
    ownOrganisationNameHint:
        "Dadurch wird Ihre Organisation in Patient Watch angelegt. Kollegen können Sie später einladen.",
    organisationNameTooShort: "Bitte geben Sie einen Organisationsnamen mit mindestens 3 Zeichen ein.",
    signupSessionExpired:
        "Ihre Registrierungssitzung ist abgelaufen. Gehen Sie zurück und fordern Sie einen neuen Code an.",
    loadingSignup: "Registrierung wird geladen…",
    welcomeToPatientWatch: "Willkommen bei Patient Watch",
    invitedByLine: (name) => `${name} hat Sie eingeladen, Patient Watch beizutreten.`,
    welcomeFirstTime: "Willkommen - das scheint Ihr erstes Mal hier zu sein.",
    choosePasswordDescription: "Wählen Sie ein Passwort, um die Einrichtung Ihres Kontos abzuschließen.",
    alreadyHavePasswordSkip: "Überspringen - ich habe bereits ein Passwort",
    finishProfileSetup: "Lassen Sie uns die Einrichtung Ihres Profils abschließen.",
    continueToProfileSetup: "Weiter zur Profileinrichtung",
    alreadySignedIn: "Bereits angemeldet",
    alreadySignedInDescription:
        "Fahren Sie mit der App fort, oder melden Sie sich ab, wenn Sie ein anderes Konto benötigen (z. B. um eine Einladung oder einen Registrierungslink zu öffnen, während Sie bereits angemeldet sind).",
    continueToProfile: "Fortfahren",
    continueToApp: "Fortfahren",
    notLoggedInResetPassword: "Sie sind nicht angemeldet. Um Ihr Passwort zurückzusetzen, gehen Sie zu:",
    authenticationComplete: "Authentifizierung abgeschlossen",
    authenticationCompleteDescription: "Sie sind jetzt angemeldet. Klicken Sie auf Weiter, um fortzufahren.",
    authenticationFailed: "Authentifizierung fehlgeschlagen",
    authenticationFailedDescription: "Link ungültig, bitte versuchen Sie es erneut.",
    noAccountFound: "Kein Konto gefunden",
    noAccountForContact: (contact) => `Kein Konto für ${contact}`,
    noAccountForDetails: "Wir konnten kein Konto mit diesen Angaben finden.",
    inviteOnlyPlatform:
        "Patient Watch ist eine reine Einladungsplattform. Bitte wählen Sie Ihre Rolle, um fortzufahren:",
    iAmPatient: "Ich bin Patient",
    iAmClinician: "Ich bin Behandler",
    wrongEmailGoBack: "Falsche E-Mail eingegeben?",
    goBackAndTryAgain: "Zurück und erneut versuchen.",
    noAccountChoosePath:
        "Wenn Sie Behandler sind, können Sie sofort kostenlos starten. Wenn Sie Patient sind, brauchen Sie eine Einladung.",
    noAccountPatientTitle: "Patienten",
    noAccountPatientDescription:
        "Patient Watch ist für Patienten nur auf Einladung. Bitten Sie Ihre Klinik um eine Einladung, oder holen Sie Hilfe, wenn Sie bereits eine Einladung haben sollten.",
    noAccountPatientCta: "Ich brauche Hilfe als Patient",
    noAccountClinicianTitle: "Behandler",
    noAccountClinicianDescription:
        "Laden Sie Patienten ein, erfassen Sie Outcome-Scores und sehen Sie Fortschritte im Zeitverlauf - kostenlos starten, keine Karte nötig. Upgraden Sie erst, wenn Ihre Fallzahl wächst.",
    noAccountClinicianCta: "Kostenloses Konto erstellen",
    confirmAccountInviteTitle: "Sie sind eingeladen, Patient Watch beizutreten",
    couldNotVerifyContact: "Wir konnten Ihre Kontaktdaten nicht verifizieren",
    invitedToJoin: "Sie sind eingeladen, Patient Watch beizutreten",
    inviterInvitedYou: (name) => `${name} hat Sie eingeladen.`,
    confirmPhoneInviteBody:
        "Bestätigen Sie unten Ihre Telefonnummer. Wir senden Ihnen einen Bestätigungscode per SMS, damit Sie die Einrichtung Ihres Kontos abschließen können.",
    confirmEmailInviteBody:
        "Bestätigen Sie unten Ihre E-Mail-Adresse. Wir senden Ihnen einen Bestätigungscode, damit Sie die Einrichtung Ihres Kontos abschließen können.",
    useInvitationContactDetails: "Verwenden Sie Ihre Einladungs-Kontaktdaten",
    enterInvitationContactHint:
        "Geben Sie die E-Mail-Adresse oder Telefonnummer ein, an die Ihre Patient-Watch-Einladung gesendet wurde.",
    enterConfirmationCode: "Bestätigungscode eingeben",
    processing: "Wird verarbeitet",
    verifyYourEmailTitle: "E-Mail verifizieren",
    verifyEmailIcon: "E-Mail verifizieren",
    emailConfirmed: "E-Mail bestätigt",
    emailConfirmedDescription: "Sie können sich jetzt anmelden.",
    verifyEmailWelcome: (firstName) =>
        `Willkommen${firstName ? `, ${firstName}` : ""}! Wir müssen Ihre E-Mail-Adresse verifizieren.`,
    verifyEmailSendHint: "Wir senden einen 6-stelligen Bestätigungscode an diese E-Mail-Adresse.",
    sendingCodeButton: "Code wird gesendet...",
    sendVerificationCodeButton: "Bestätigungscode senden",
    enterVerificationCode: "Bestätigungscode eingeben",
    enterCodeSentTo: (email) => `Bitte geben Sie den Code ein, der an ${email} gesendet wurde`,
    checkJunkFolder: "Vergessen Sie nicht, Ihren Spam-Ordner zu prüfen!",
    deleteAccount: "Konto löschen",
    deleteAccountReason: "Grund für die Kontolöschung",
    troubleAccessingTitle: "Probleme beim Zugriff auf Patient Watch?",
    patientInviteMismatch: (email) =>
        `Wenn Sie eine Einladung erhalten haben, prüfen Sie bitte, ob die eingeladene E-Mail-Adresse mit ${email} übereinstimmt.`,
    patientContactProvider:
        "Wenn Sie glauben, eine Einladung erhalten zu haben, wenden Sie sich bitte an Ihren Behandlungsanbieter, um Ihre Angaben zu bestätigen.",
    contactSupportTeam: "Support-Team kontaktieren",
    interestedInPwTitle: "Interesse an Patient Watch?",
    interestedInPwBody1: "Überwachen Sie Patientenergebnisse und bleiben Sie mit Ihrer Praxis verbunden.",
    signupStarterPlan: "Bezahlte Pläne ansehen",
    carePlanInjection: "Ihr Behandlungsplan umfasst eine Injektion.",
    carePlanInjectionTo: (where, substance, amount) => {
        if (where && substance && amount) return `Injektion in ${where}: ${substance} (${amount}).`;
        if (where && substance) return `Injektion in ${where}: ${substance}.`;
        if (where && amount) return `Injektion in ${where} (${amount}).`;
        if (where) return `Nachsorge nach einer Injektion in ${where}.`;
        if (substance && amount) return `Injektion: ${substance} (${amount}).`;
        if (substance) return `Injektion: ${substance}.`;
        return "";
    },
    carePlanSurgery: "Ihr Behandlungsplan umfasst eine Operation.",
    carePlanSurgeryArea: (area) => `Ihr Behandlungsplan umfasst eine Operation (${area}).`,
    carePlanShockwave: "Ihr Behandlungsplan umfasst eine Stoßwellentherapie.",
    authErrorTitle: "Authentifizierungsfehler",
    linkExpiredTitle: "Dieser Link ist abgelaufen",
    almostThere: "Fast geschafft!",
    preparingAccount: "Einen Moment, wir bereiten Ihr Konto vor...",
    verifyEmailCallBody: (email) =>
        `Bitte geben Sie den Code ein, der an ${email} gesendet wurde.\n\nVergessen Sie nicht, Ihren Spam-Ordner zu prüfen!`,
    verifyingPhone: "Telefonnummer wird verifiziert",
    verifyingEmail: "E-Mail wird verifiziert",
    phoneVerified: "Telefon verifiziert",
    emailVerified: "E-Mail verifiziert",
    verifyingPhoneWait: "Einen Moment, wir verifizieren Ihre Telefonnummer...",
    verifyingEmailWait: "Einen Moment, wir verifizieren Ihre E-Mail...",
    phoneVerifiedSuccess: "Ihre Telefonnummer wurde erfolgreich verifiziert! Lassen Sie uns Ihr Konto einrichten.",
    emailVerifiedSuccess: "Ihre E-Mail wurde erfolgreich verifiziert! Lassen Sie uns Ihr Konto einrichten.",
    verifyPhoneError:
        "Bitte versuchen Sie erneut, Ihre Telefonnummer zu verifizieren, oder kontaktieren Sie support@patient-watch.com",
    verifyEmailError:
        "Bitte versuchen Sie erneut, Ihre E-Mail zu verifizieren, oder kontaktieren Sie support@patient-watch.com",
    verificationError: "Verifizierungsfehler",
    tryAgain: "Erneut versuchen",
    freemiumSignupTitle: "Kostenloses Konto erstellen",
    freemiumSignupDescription:
        "Laden Sie Patienten ein, erfassen Sie Outcome-Scores und begleiten Sie ihre Genesung - in Minuten startklar, keine Karte nötig.",
    freemiumSignupBenefit1: "Laden Sie Patienten ein und erfassen Sie Outcome-Scores sofort",
    freemiumSignupBenefit2: "Automatische Erinnerungen halten Patienten zwischen den Terminen engagiert",
    freemiumSignupBenefit3: "Sehen Sie Fortschritte im Zeitverlauf im klaren Behandler-Dashboard",
    freemiumSignupCta: "Kostenloses Konto erstellen",
    freemiumSignupSubmitting: "Konto wird erstellt…",
    freemiumSignupUpgradeHint: "Benötigen Sie höheres Volumen?",
    freemiumSignupSeePaidPlans: "Andere Pläne ansehen",
    diaryInviteUnavailableTitle: "Diese Einladung ist nicht verfügbar",
    diaryInviteUnavailableCallout: "Kein Tagebuch gestartet",
    diaryInviteUnavailableBody: "Mit dem aktuellen Plan kann kein weiteres Tagebuch hinzugefügt werden.",
    diaryInviteUnavailableNextStep:
        "Bitte kontaktieren Sie Ihre Klinik. Sie können Sie erneut einladen, sobald Kapazität vorhanden ist.",
    diaryInviteOwnerUnresolvedBody:
        "Dieses Tagebuch konnte nicht gestartet werden. Bitte fragen Sie nach einem neuen Einladungslink.",
    mfaEnrollTitle: "Authentifikator einrichten",
    mfaEnrollDescription:
        "Scannen Sie diesen QR-Code und geben Sie anschließend den sechsstelligen Code aus Ihrer App ein.",
    mfaManualSetup: "QR-Code kann nicht gescannt werden?",
    mfaQrCodeAlt: "QR-Code zur Einrichtung der Authenticator-App",
    mfaChallengeTitle: "Zwei-Faktor-Authentifizierung",
    mfaChallengeDescription: "Geben Sie den sechsstelligen Code aus Ihrer Authentifikator-App ein.",
    mfaAuthenticatorCode: "Authentifikator-Code",
    mfaVerifyCode: "Code bestätigen",
    mfaVerifying: "Wird bestätigt…",
    mfaLoading: "Wird geladen…",
    mfaSettingsTitle: "Authentifikator-Sicherheit",
    mfaSettingsDescription: "Ihr Authentifikator ist für privilegierten Zugriff erforderlich.",
    mfaFactorActive: "Authentifikator aktiv",
    mfaReplaceFactor: "Authentifikator ersetzen",
    mfaReplaceConfirm: "Diesen Authentifikator entfernen und jetzt einen Ersatz einrichten?",
};
